import { useState, KeyboardEvent, useEffect, useRef } from 'react'
import { Button, Input } from '@wellesley/ui'

type ExternalURLTabProps = {
  onInsert: (url: string) => void
  isActive: boolean
}

export const ExternalURLTab = ({ onInsert, isActive }: ExternalURLTabProps) => {
  const [externalUrl, setExternalUrl] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isActive) {
      // Double requestAnimationFrame to ensure the tab has been fully rendered
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          inputRef.current?.focus()
        })
      })
    }
  }, [isActive])

  const handleInsert = () => {
    if (externalUrl.trim()) {
      onInsert(externalUrl.trim())
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleInsert()
    }
  }

  return (
    <div className="space-y-s">
      <div className="text-sm text-gray-600">
        Insert an image from an external URL
      </div>
      <Input
        ref={inputRef}
        placeholder="https://example.com/image.jpg"
        value={externalUrl}
        onChange={(e) => setExternalUrl(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus={isActive}
      />
      <Button
        onClick={handleInsert}
        disabled={!externalUrl.trim()}
        className="w-full"
      >
        Insert
      </Button>
    </div>
  )
}
